// extracted by mini-css-extract-plugin
export var arrow = "_47-6";
export var changeItem = "_47-3";
export var changesHeader = "_47-1";
export var changesList = "_47-2";
export var container = "_47-0";
export var pathLabel = "_47-4";
export var value = "_47-7";
export var valuesContainer = "_47-5";